var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{class:_vm.rowClass},_vm._l((_vm.cols),function(col){return _c('td',{key:col.id,class:col.cssClasses,attrs:{"styles":col.inlineStyles,"column":col.id}},[_c('cell-wrapper',{attrs:{"row":_vm.row,"col":col}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }